/* global axios */
import ApiClient from '../ApiClient';

// Fase 59 — catálogo do que a conta vende. Alimenta a subpágina
// Pipeline › Oportunidades e, mais adiante, o modal de ganho.
class PipelineProductsAPI extends ApiClient {
  constructor() {
    super('pipeline/products', { accountScoped: true });
  }

  list({ activeOnly, pipelineId, perPage, offset } = {}) {
    const params = {};
    if (activeOnly !== undefined) params.active_only = activeOnly;
    if (pipelineId !== undefined) params.pipeline_id = pipelineId;
    if (perPage !== undefined) params.per_page = perPage;
    if (offset !== undefined) params.offset = offset;

    return axios.get(this.url, { params });
  }

  // Desempenho por produto no período. Devolve TODOS os produtos (inclusive os
  // que não venderam) e, à parte, as vendas sem produto vinculado.
  performance({ wonStart, wonEnd, pipelineId } = {}) {
    const params = {};
    if (wonStart) params.won_start = wonStart;
    if (wonEnd) params.won_end = wonEnd;
    if (pipelineId !== undefined && pipelineId !== null) {
      params.pipeline_id = pipelineId;
    }

    return axios.get(`${this.url}/performance`, { params });
  }

  createProduct(payload) {
    return axios.post(this.url, { pipeline_product: payload });
  }

  updateProduct(id, payload) {
    return axios.patch(`${this.url}/${id}`, { pipeline_product: payload });
  }

  // Desativa (o servidor faz soft): produto com histórico não pode sumir.
  deactivate(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Desativar sem poder desfazer transforma um clique errado em beco sem
  // saída — o produto some da lista de venda e não volta.
  reactivate(id) {
    return this.updateProduct(id, { active: true });
  }
}

export default new PipelineProductsAPI();
